import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const DestinationForm = ({ apiHandler, editData }) => {
    const initialValues = {
        country_name: editData?.country_name || '',
        // country_img: editData?.country_img || '',
        success_count: editData?.success_count || '',
        description: editData?.description || '',
        country: editData?.country || '',
        population: editData?.population || '',
        capital: editData?.capital || '',
        language: editData?.language || '',
        currency: editData?.currency || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='country_name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Image' required />

                <ReactInput name='country_img' type='file' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Success Count' required />

                <ReactInput name='success_count' type='number' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Description [Min 250 Words]' required />

                <ReactInput name='description' as='textarea' rows={6} />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Country' required />

                <ReactInput name='country' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Population' required />

                <ReactInput name='population' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Capital' required />

                <ReactInput name='capital' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Language' required />

                <ReactInput name='language' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Currency' required />

                <ReactInput name='currency' />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default DestinationForm;
